import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DashboardComponent } from './dashboard/dashboard.component';
import { LinksCountComponent } from './dashboard/links-count/links-count.component';
import { InventoryContentPagesComponent } from './content/pages/inventory-content-pages.component';
import { InventoryContentDocumentsNoScanComponent } from './content/documents-no-scan/inventory-content-documents-no-scan.component';
import { InventoryContentLinksComponent } from './content/links/inventory-content-links.component';
import { InventoryContentTechnicalComponent } from './content/technical/inventory-content-technical.component';
import { InventoryContentImagesComponent } from './content/images/inventory-content-images.component';
import { InventoryContentDocumentsWrapperComponent } from './content/documents-wrapper/inventory-content-documents-wrapper.component';
import { InventoryDocumentComponent } from './content/documents/inventory-document.component';
import { InventoryEmailComponent } from './email/inventory-email.component';
import { InventoryDialogsContentLinksComponent } from './dialogs/links/inventory-dialogs-content-links.component';
import { PagesEmailComponent } from '@client/app/components/pages/emails/pages-email.component';
import { InventoryRoutingModule } from './inventory-routing.module';

// Import shared components and modules
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ExportModule } from '@client/app/modules/export/export.module';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { IconsModule } from '@client/ng2/layout/icons/icons.module';
import { MonNumberPipe } from '@monsido/core/locale/pipes/mon-number.pipe';
import { LayoutModule, MonEventTriggerModule, MonTableSortModule } from '@monsido/angular-shared-components';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        DashboardComponent,
        LinksCountComponent,
        InventoryContentPagesComponent,
        InventoryContentDocumentsNoScanComponent,
        InventoryContentLinksComponent,
        InventoryContentTechnicalComponent,
        InventoryContentImagesComponent,
        InventoryDocumentComponent,
        InventoryContentDocumentsWrapperComponent,
        InventoryEmailComponent,
        InventoryDialogsContentLinksComponent,
        PagesEmailComponent,
    ],
    imports: [
        LineComponent,
        MonNumberPipe,
        CommonModule,
        FormsModule,
        InventoryRoutingModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        ExportModule,
        IconsModule,
        LayoutModule,
        NgbTooltip,
        MonEventTriggerModule,
        MonTableSortModule,
    ],
})
export class InventoryModule { }
